import React from "react";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface VocabularyFloatingActionButtonsProps {
  onEnhanceVocabulary: () => void;
  isEnhancingVocabulary: boolean;
  hasEnhancedContent?: boolean;
}

export const VocabularyFloatingActionButtons: React.FC<VocabularyFloatingActionButtonsProps> = ({
  onEnhanceVocabulary,
  isEnhancingVocabulary,
  hasEnhancedContent = false,
}) => {
  return (
    <div className="fixed right-2 sm:right-12 top-[640px] flex flex-col gap-2 z-40">
      {/* Enhance Vocabulary Button */}
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="outline"
              size="icon"
              className={`h-8 w-8 sm:h-10 sm:w-10 rounded-[10px] sm:rounded-xl ${
                hasEnhancedContent
                  ? "hover:bg-primary text-foreground"
                  : "dark:bg-primary/30 hover:bg-gray-50"
              } shadow-sm`}
              onClick={onEnhanceVocabulary}
            >
              {isEnhancingVocabulary ? (
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-current"></div>
              ) : (
                <Sparkles size={14} className={hasEnhancedContent ? "text-foreground" : ""} />
              )}
            </Button>
          </TooltipTrigger>
          <TooltipContent side="left">
            <div className="max-w-[200px]">
              <p className="font-semibold">
                {isEnhancingVocabulary 
                  ? 'Enhancing...' 
                  : hasEnhancedContent 
                    ? 'Vocabulary Enhanced' 
                    : 'Enhance Vocabulary'}
              </p>
              <p className="text-xs mt-1 text-gray-400">
                {hasEnhancedContent 
                  ? 'Practical examples and context added'
                  : 'Add practical examples and context descriptions'}
              </p>
            </div>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};
